export default [
    {
        path: 'menu/list',
        name: 'organization_menu_list',
        meta: { isCache: true, icon: 'md-menu', hideInMenu: false },
        component: () => import('@/views/organization/menu/menu-list.vue'),
    },
    {
        path: 'menu/add',
        name: 'organization_menu_add',
        meta: { isCache: true, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/organization/menu/menu-add.vue'),
    },
    {
        path: 'menu/edit/:id',
        name: 'organization_menu_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/organization/menu/menu-edit.vue'),
    },
    {
        path: 'menu/detail/:id',
        name: 'organization_menu_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/organization/menu/menu-detail.vue'),
    },
];
